if (typeof ol === 'object') {
	class Drag extends ol.interaction.Pointer {
		constructor() {
			super({
				handleDownEvent: function (evt) {
					const map = evt.map;
					const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
						return feature;
					});
					if (feature) {
						this.coordinate_ = evt.coordinate;
						this.feature_ = feature;
					}
					return !!feature;
				},
				handleDragEvent: function (evt) {
					const deltaX = evt.coordinate[0] - this.coordinate_[0];
					const deltaY = evt.coordinate[1] - this.coordinate_[1];

					const geometry = this.feature_.getGeometry();
					geometry.translate(deltaX, deltaY);

					this.coordinate_[0] = evt.coordinate[0];
					this.coordinate_[1] = evt.coordinate[1];

					if (this.latInput && this.lngInput) {
						const gps = ol.proj.transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');
						this.lngInput.value = gps[0].toFixed(7);
						this.latInput.value = gps[1].toFixed(7);
					}
					// console.log();
				},
				handleMoveEvent: function (evt) {
					if (this.cursor_) {
						const map = evt.map;
						const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
							return feature;
						});
						const element = evt.map.getTargetElement();
						if (feature) {
							if (element.style.cursor !== this.cursor_) {
								this.previousCursor_ = element.style.cursor;
								element.style.cursor = this.cursor_;
							}
						} else if (this.previousCursor_ !== undefined) {
							element.style.cursor = this.previousCursor_;
							this.previousCursor_ = undefined;
						}
					}
				},
				handleUpEvent: function () {
					this.coordinate_ = null;
					this.feature_ = null;
					return false;
				},
			});

			this.coordinate_ = null;
			this.cursor_ = 'move';
			this.feature_ = null;
			this.previousCursor_ = undefined;
			this.latInput = document.getElementById('reportLocationLat');
			this.lngInput = document.getElementById('reportLocationLng');
		}
	}

	jQuery($ => {
		const defaultLon = 17.9135;  // Vp középpont
		const defaultLat = 47.0927;

		if ($('#map').hasClass('add-poi')) {
			$('#reportLocationLng').val(defaultLon);
			$('#reportLocationLat').val(defaultLat);
		}

		$(document.body).on('map/init', function () {
			const mapElement = document.getElementById('map');
			if (!mapElement) {
				return;
			}

			const defaultInteractionsSettings = { mouseWheelZoom: false, onFocusOnly: true };
			const interactions = mapElement.classList.contains('add-poi') ?
				ol.interaction.defaults(defaultInteractionsSettings).extend([new Drag({})]) :
				ol.interaction.defaults(defaultInteractionsSettings);
			const map = new ol.Map({
				target: 'map',
				layers: [
					new ol.layer.Tile({
						source: new ol.source.OSM()
					}),
				],
				view: new ol.View({
					center: ol.proj.fromLonLat([defaultLon, defaultLat]),
					zoom: 14
				}),
				interactions,
			});
			window.veszpremMap = map;
			if (mapElement.classList.contains('add-poi')) {
				window.mapMarkers = [{
					id: 0,
					lat: defaultLat,
					lon: defaultLon,
				}];
			}
			if (window.mapMarkers) {

				const markers = new ol.layer.Vector({
					source: new ol.source.Vector({
						features: window.mapMarkers.map(m => new ol.Feature({...m, geometry: new ol.geom.Point(ol.proj.fromLonLat([m.lon, m.lat]))})),
					}),
					style: new ol.style.Style({
						image: new ol.style.Icon({
							anchor: [0.5, 1],
							src: window.veszprem_map_marker_blue_src || 'images/map-marker-blue.svg'
						})
					}),
				});
				map.addLayer(markers);

				const popupContainer = document.getElementById('popup');
				const popupContent = document.getElementById('popup-content');
				const popupCloser = document.getElementById('popup-closer');

				if (!popupContainer) {
					return;
				}

				const popupOverlay = new ol.Overlay({
					element: popupContainer,
					autoPan: true,
					autoPanAnimation: {
						duration: 250
					}
				});
				map.addOverlay(popupOverlay);

				popupCloser.addEventListener('click', function () {
					popupOverlay.setPosition(undefined);
					popupCloser.blur();
					return false;
				});

				map.on('singleclick', function (event) {
					const features = map.getFeaturesAtPixel(event.pixel);
					if (features.length > 0) {
						const poi = features[0];
						popupOverlay.setPosition(event.coordinate);
						const imgWrapper = popupContent.querySelector('.img-wrapper');
						poi.get('is_nsfw') ? imgWrapper.classList.add('is-nsfw') : imgWrapper.classList.remove('is-nsfw');
						popupContent.querySelector('img').src = poi.get('image');
						const badgeElement = popupContent.querySelector('.badges .badge');
						badgeElement.innerText = poi.get('badge_title');
						badgeElement.classList.forEach(c => c.startsWith('bg-') ? badgeElement.classList.remove(c) : null);
						badgeElement.classList.add(poi.get('badge_color'))
						popupContent.querySelector('h3').innerText = poi.get('title');
						const attrWrapper = popupContent.querySelector('.attrs');
						const attrTemplate = attrWrapper.getAttribute('data-attr-template');
						const attrs = poi.get('attrs');
						attrWrapper.innerHTML = '';
						attrs.forEach(attr => {
							attrWrapper.innerHTML += attrTemplate.replace('%1', attr.icon).replace('%2', attr.title);
						});
						popupContent.querySelector('p.description').innerText = poi.get('description');
						if (window.innerWidth < 992) {
							popupOverlay.setPositioning('bottom-center');
							popupOverlay.setOffset([0, -24]);
						} else {
							popupOverlay.setPositioning('center-left');
							popupOverlay.setOffset([24, 0]);
						}
					} else {
						popupOverlay.setPosition(undefined);
						popupCloser.blur();
					}
				});
			}
		}).trigger('map/init');
	});
}
